// tslint:disable-next-line: no-namespace
export namespace NotificationAction {
    export class GetNotifications {
        static readonly type = '[Notification] GetNotifications';
        constructor() {}
    }

    export class LoadMoreNotifications {
        static readonly type = '[Notification] LoadMoreNotifications';
        constructor() {}
    }

    export class ReadNotification {
        static readonly type = '[Notification] ReadNotification';
        constructor(public payload: any) {}
    }

    export class ResetNotification {
        static readonly type = '[Notification] ResetNotification';
        constructor(public payload: string) {}
    }

    export class GetNotificationUnReadCount {
        static readonly type = '[Notification] GetNotificationUnReadCount';
        constructor() {}
    }
}
